// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioButtonGroup__container-d6c895 {
  padding: 0;
  margin: 8px 0;
  border: none;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/RadioButtonGroup/RadioButtonGroup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,YAAA;AACF","sourcesContent":[".container {\n  padding: 0;\n  margin: 8px 0;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RadioButtonGroup__container-d6c895`
};
module.exports = ___CSS_LOADER_EXPORT___;
